import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
const defaultStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    fontSize: '6pt',
    color: '#a6a6a6',
    marginLeft: '2mm',
    marginRight: '2mm',
};
const styleHeader = {
    // rpx-header
    position: 'absolute',
    top: '1mm',
};
const styleFooter = {
    // rpx-footer
    position: 'absolute',
    bottom: '1mm',
};
/**
 * https://pptr.dev/#?product=Puppeteer&version=v1.5.0&show=api-class-page
 * headerTemplate / footerTemplate
 */
export const PagePart = (props) => {
    const style = useMemo(() => {
        switch (props.id) {
            case 'rpx-header':
                return { ...defaultStyle, ...styleHeader };
            case 'rpx-footer':
                return { ...defaultStyle, ...styleFooter };
            default:
                return defaultStyle;
        }
    }, [props.id]);
    return (_jsx("div", { id: props.id, style: { display: 'none' }, children: _jsx("div", { style: style, children: props.parts.map((part, key) => (_jsx("span", { className: part.class, style: part.style, children: part.text }, key))) }) }));
};
//# sourceMappingURL=component.js.map